import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{~#each this.tokens as |token|~}}\n  {{~#if token.variable~}}\n    {{~yield token.variable.value token.variable.name}}\n  {{~/if~}}\n  {{~#if token.text~}}\n    {{~token.text~}}\n  {{~/if~}}\n{{~/each~}}", {
  moduleName: "@qonto/ui-kit/components/translation-with-args.hbs"
});